import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";
import DateService from "../../../services/DateService";
import { DisplayListPagination } from "../../../components/TapUi";
import TapHelper from "../../../services/TapHelper";

const TicketsEventListModal = ({ isOpen, selectedDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [meta, setMeta] = useState({});
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchTicketsDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchTicketsDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };

            const params = {
                search_date_from: selectedDate,
                search_date_to: selectedDate,
                search_ticket_status: ['5', '20'],
                per_page: 20,
                page: page
            };

            const response = await api.server2Api.get(`${IAM_API_BASE_URL_2}/ticket/list`, {
                params, headers
            });
            const responseData = response.data || {};
            console.log(responseData);
            

            setMeta(
                TapHelper.pick(responseData.meta, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );

            setEvents(responseData.data || [])
        } catch (error) {
            toast.error('Failed to load Tickets details');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Tickets for {DateService.dateFormat(selectedDate, 'DD MMM YYYY')}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "10%" }}>Ticket No</th>
                                            <th scope="col" style={{ width: "15%" }}>Ticket Header</th>
                                            <th scope="col" style={{ width: "15%" }}>Ticket Type</th>
                                            <th scope="col" style={{ width: "15%" }}>Site Name</th>
                                            <th scope="col" style={{ width: "15%" }} className="text-center">Created Date</th>
                                            <th scope="col" style={{ width: "15%" }} className="text-center">Due Date</th>
                                            <th scope="col" style={{ width: "15%" }} className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => {
                                                const dateParts = event?.start_date_display.split('-');
                                                const dateStr = `${dateParts[1]} ${dateParts[0]}, ${dateParts[2]}`;
                                                const date = new Date(dateStr);

                                                const estimateDays = event.estimate_days;
                                                date.setDate(date.getDate() + estimateDays);

                                                const options = { day: '2-digit', month: 'short', year: 'numeric' };
                                                const formattedDate = date.toLocaleDateString('en-GB', options).replace(/ /g, '-');


                                                return (<>
                                                    <tr key={event.id || index}>
                                                        <td className='text-center'>
                                                            {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                        </td>
                                                        <td>
                                                            {event.activity_id || '-'}
                                                        </td>
                                                        <td>{event.header}</td>
                                                        <td>{event.ticket_type_name || '-'}</td>
                                                        <td>{event.site?.site_name || '-'}</td>
                                                        <td className='text-center'>
                                                            {event.created_at_date || '-'}
                                                        </td>
                                                        <td className='text-center'>
                                                            {formattedDate || '-'}
                                                        </td>
                                                        <td className='text-center'>
                                                            <Status color={event?.status_color}>
                                                                {event?.status_text}
                                                            </Status>
                                                        </td>
                                                    </tr>
                                                </>)
                                            }
                                            )
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={8}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchTicketsDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketsEventListModal;